var map = {
	"./033-bm.webp": 1191,
	"./033-cn.webp": 1192,
	"./033.webp": 1193,
	"./13-bm.webp": 1194,
	"./13-cn.webp": 1195,
	"./13.webp": 1196,
	"./3-bm.webp": 1197,
	"./3-cn.webp": 1198,
	"./3.webp": 1199,
	"./angpao-bg-mobile.jpg": 1200,
	"./angpao-bg.jpg": 1201,
	"./angpao-bm.webp": 1202,
	"./angpao-cn.webp": 1203,
	"./angpao.webp": 1204,
	"./button.png": 1205,
	"./close-eye.png": 1206,
	"./coin-1.png": 1207,
	"./coin.png": 1208,
	"./ketupak-open.png": 1209,
	"./ketupak.png": 1210,
	"./ketupak_ribbon.png": 1211,
	"./rain-1.png": 1212,
	"./rain-2.png": 1213,
	"./rain-3.png": 1214,
	"./raya-bg-mobile.png": 1215,
	"./raya-bg.png": 1216,
	"./shine.png": 1217,
	"./star-1.png": 1218,
	"./star-2.png": 1219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;